// 获取MSC补充信息
import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function multiLegVoyageManagementUrlFunc(data) {
  return request({
    url: URL.seaExport.multiLegVoyageManagementUrl,
    method: 'post',
    data
  })
}
